define('modules/start/model',['require','exports','module','base/model'],function (require, exports, module) {
  'use strict';

  var BaseModel = require('base/model');

  var Model = BaseModel.extend({
    getCompanyIdRedirect: function (companyId) {
      if (_.isNumber(companyId)) {
        return companyId;
      }

      return this.getFirstCompanyFromService();
    },

    getFirstCompanyFromService: function () {
      var company;
      var productCompanies = this.get('companies');

      company = _.find(productCompanies, function (cmp) {
        return cmp.activeServiceCompany === true;
      });

      return company ? company.id : null;
    },

    isActive: function (isAdm, companyId) {
      if (isAdm) {
        return companyId ? this.oneCompanyIsActive(companyId) : this.anyCompanyIsActive();
      }

      return companyId ? this.myCompanyIsActive(companyId) : this.myCompaniesAreActive();
    },

    oneCompanyIsActive: function (companyId) {
      var companies = this.get('companies');
      var company = _.find(companies, function (currentCompany) {
        return (
            parseInt(currentCompany.id) === parseInt(companyId) &&
            currentCompany.activeServiceCompany
        );
      }, this);

      return company ? company.id : false;
    },

    anyCompanyIsActive: function () {
      var companies = this.get('companies');
      var company = _.find(companies, function (currentCompany) {
        return (
            currentCompany.status &&
            this.get('activeServiceUser')
        );
      }, this);

      return company ? company.id : false;
    },

    myCompanyIsActive: function (companyId) {
      var companies = this.get('companies');
      var company = _.find(companies, function (currentCompany) {
        return (
            parseInt(currentCompany.id) === parseInt(companyId) &&
            currentCompany.activeServiceCompany
        );
      }, this);

      return company ? company.id : false;
    },

    myCompaniesAreActive: function () {
      var companies = this.get('companies');
      var company = _.find(companies, function (currentCompany) {
        return (
            currentCompany.status &&
            currentCompany.activeServiceCompany
        );
      }, this);

      return company ? company.id : false;
    },

    wasAlreadyActivated: function () {
      return (
          this.get('active') &&
          this.get('deactivated_companies').length > 0
      );
    }
  });

  module.exports = Model;
});

